import { useEffect } from 'react';
import { FormikProps } from 'formik';

import { CustomerInfoFormValues } from '../../CustomerInfo';

type FieldName = 'firstName' | 'lastName' | 'email' | 'phone';

interface Options {
  originalFieldName: FieldName;
  dependentFieldName?: FieldName;
  formik: FormikProps<CustomerInfoFormValues>;
}

// Update appropriate timesheet approver field depending on supervisor field change
export default function useSupervisorDependentField(options: Options) {
  const {
    formik,
    originalFieldName,
    dependentFieldName = originalFieldName,
  } = options;
  const supervisorDependentFieldName =
    formik.values.supervisorInfo[dependentFieldName];

  useEffect(() => {
    if (formik.values.timesheetApproverInfo.sameAsSupervisor) {
      formik.setFieldValue(
        `timesheetApproverInfo.timesheetApprovers[0].${originalFieldName}`,
        supervisorDependentFieldName,
        false,
      );
      formik.setFieldTouched(
        `timesheetApproverInfo.timesheetApprovers[0].${originalFieldName}`,
        false,
        false,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    supervisorDependentFieldName,
    formik.values.timesheetApproverInfo.sameAsSupervisor,
  ]);

  return null;
}
